import { SVGProps } from 'react';

const DatabaseZap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v3M3 5v14c-.006.48.336.955.995 1.383.66.428 1.618.796 2.795 1.075s2.536.458 3.965.525c1.429.066 2.885.017 4.245-.143M21 12l-3 5h4l-3 5M3 12c.002.467.33.928.962 1.346.63.418 1.545.78 2.671 1.06 1.126.278 2.432.465 3.813.546 1.382.08 2.8.053 4.144-.082"
    />
  </svg>
);
export default DatabaseZap;
